import React, { forwardRef } from "react";
import TinyPopover from "react-tiny-popover";
import PropTypes from "prop-types";

import "./styles.scss";

const Popover = forwardRef((props, ref) => (
  <TinyPopover
    ref={ref}
    containerClassName={`mydpd-popover mydpd-popover--${props.position}`}
    {...props}
  />
));

Popover.defaultTypes = {
  position: "top",
};

Popover.propTypes = {
  position: PropTypes.string,
};

export default Popover;
